<template>
    <Core :avatar="avatar" :nickname="nickname" />
</template>

<script>
/* eslint-disable vue/multi-word-component-names */
import Core from './core';
import { query2obj } from './utils.js';
import { NICKNAME_PLACEHOLDER } from '../constant/enum.js';
const {
    common: {
        request: { bindCommonApi }
    }
} = require('@futuweb/fego-render');

const commonApiRequest = bindCommonApi('inviter');

export default {
    name: 'inviter',
    components: {
        Core
    },
    props: {
        displayAvatar: {
            type: Boolean,
            default: true
        },
        defaultAvatar: {
            type: String,
            default: ''
        },
        nameFormat: {
            type: String,
            default: ''
        },
        noInviterDisplayAvatar: {
            type: Boolean,
            default: false
        },
        noInviterAvatar: {
            type: String,
            default: ''
        },
        noInviterText: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            avatar: '',
            nickname: ''
        };
    },
    async created() {
        await this.getInviter();
        if (!this.nickname) {
            this.avatar = this.noInviterDisplayAvatar ? this.noInviterAvatar : '';
            this.nickname = this.noInviterText;
        }
    },
    methods: {
        // 初始化参数
        initParams() {
            const query = query2obj();
            if (!query.global_content) {
                return;
            }

            try {
                const json = JSON.parse(query.global_content);
                if (json.promote_id || json.invite) {
                    return {
                        invite: json.invite,
                        promote_id: json.promote_id,
                        sub_promote_id: json.sub_promote_id || 1
                    };
                }
            } catch (error) {
                console.log(error);
            }
        },
        async getInviter() {
            const global_content = this.initParams();
            if (!global_content) {
                return;
            }

            const params = {};
            if (global_content.invite) {
                params.invite = global_content.invite;
            }
            if (global_content.promote_id) {
                params.promote_id = global_content.promote_id;
                params.sub_promote_id = global_content.sub_promote_id || 1;
            }
            if (Object.keys(params).length === 0) {
                return;
            }

            const inviter = await commonApiRequest.get('inviter', params);
            if (!inviter) {
                return;
            }

            this.avatar = this.displayAvatar ? inviter.avatar || this.defaultAvatar : '';
            this.nickname = this.nameFormat.replace(NICKNAME_PLACEHOLDER, inviter.nickname);
        }
    }
};
</script>
